import { useAuth, AUTH_STATES } from "../auth";
import { useBootstrap } from "./useBootstrap";
import { bootstrapQueryKey } from "./bootstrapQuery";

export function useUser() {
  const { status, user: leanUser } = useAuth();
  const bootstrap = useBootstrap();

  const isLoading = status === AUTH_STATES.RESTORING || bootstrap.isLoading;
  const isReady = status === AUTH_STATES.AUTHENTICATED && bootstrap.isSuccess;

  return {
    leanUser,
    bootstrap,
    isLoading,
    isReady,
  };
}

/**
 * Write a fresh user object into the bootstrap cache.
 * Call this whenever the server returns an updated user
 *
 * Every component calling useUser() or useBoostrap will re-render
 * automatically with the new data. No prop drilling
 *
 * @param {QueryClient} queryClient - from useQueryClient
 * @param {string} userId
 * @param {object} freshUser - the updated user object from the server
 */

export function seedUserCache(queryClient, userId, incomingData) {
  queryClient.setQueryData(bootstrapQueryKey(userId), (prev) => ({
    ...prev,
    ...incomingData,
  }));
}
